<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="优惠券模板" prop="templateId">
        <el-select
          v-model="form.templateId"
          placeholder="请选择优惠券模板"
          filterable
          remote
          reserve-keyword
          :loading="tagLoading"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in couponList"
            :key="itemIndex"
            :label="item.couponName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券编码" prop="couponCode">
        <el-input
          v-model="form.couponCode"
          placeholder="请输入优惠券编码"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="关联用户" prop="userId">
        <el-select
          v-model="form.userId"
          placeholder="请选择要关联的用户"
          filterable
          remote
          reserve-keyword
          :remote-method="getUserList"
          :loading="tagLoading"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in forUserList"
            :key="itemIndex"
            :label="item.mobile"
            :value="item.id"
          >
            <div style="display: flex; align-items: center">
              <el-avatar
                shape="circle"
                style="width: 50px; height: 50px"
                fit="cover"
                :src="imgUrl + item.avatar"
              ></el-avatar>
              <div style="padding-left: 8px">
                <span
                  ><b>{{ item.username }}</b></span
                >
                <div>手机: {{ item.mobile }}</div>
              </div>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="截止时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="form.status"
          placeholder="请选择状态"
          filterable
          remote
          reserve-keyword
          :loading="tagLoading"
          @keypress.enter.native="search"
        >
          <el-option
            v-for="(item, itemIndex) in statusList"
            :key="itemIndex"
            :label="item.status"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="核销时间" prop="usedTime">
        <el-date-picker
          v-model="form.usedTime"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { fetchList } from '../../api/system/user'
import { fetchList as fetchCouponList } from '../../api/rentHouse/couponTemplate'

export default {
  name: 'OperaCouponListWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: '',
        couponCode: '',
        couponName: '',
        delFlag: 0,
        endTime: '',
        startTime: '',
        status: null,
        usedTime: '',
        templateId: null,
        userId: null,
        scene: null
      },
      forUserList: [],
      imgUrl: process.env.VUE_APP_API_IMG,
      tagLoading: false,
      statusList: [
        {
          id: '0',
          status: '待核销'
        },
        {
          id: '1',
          status: '已过期'
        },
        {
          id: '2',
          status: '已核销'
        },
        {
          id: '3',
          status: '待支付'
        },
        {
          id: '4',
          status: '待领取'
        }
      ],
      select: '',
      couponList: [],
      // 验证规则
      rules: {
        templateId: [{ required: true, message: '请选择优惠券模板' }],
        userId: [{ required: true, message: '请选择关联用户' }]
      }
    }
  },
  created () {
    this.config({
      api: '/rentHouse/couponList',
      'field.id': 'id'
    })
    const extendsOpen = this.open.bind(this)
    this.open = (title, target) => {
      extendsOpen(title, target)
      this.getCouponList()
      this.getUserList('', (target && target.forUserId) || '')
      // 在下一个 tick 中生成优惠券编码，确保在表单重置之后
      this.$nextTick(() => {
        if (target == null) {
          this.form.couponCode = this.generateRandomCode()
          this.form.status = '待领取'
        } else {
          // 编辑模式：将数字状态转换为状态文字
          if (target.status !== null && target.status !== undefined) {
            this.form.status = this.getStatusText(target.status)
          }
        }
      })
    }
    const actionConfirm = this.confirm.bind(this)
    this.confirm = (...data) => {
      const selected = this.couponList.find(
        (item) => item.id === this.form.templateId
      )
      this.form.couponName = selected?.couponName
      this.form.templateId = selected?.id
      this.form.scene = selected?.useScene
      return actionConfirm(...data)
    }
  },
  methods: {
    async getUserList (keyword, defaultUserId = '') {
      const res = await fetchList({
        page: 1,
        capacity: 50,
        model: {
          id: defaultUserId,
          username: '',
          nickName: '',
          realname: '',
          mobile: keyword
        },
        sorts: [{ property: 'CREATE_TIME', direction: 'DESC' }]
      })

      this.forUserList = res.records
    },
    async getCouponList () {
      const res = await fetchCouponList({
        page: 1,
        capacity: 50
      })
      this.couponList = res.records
    },
    generateRandomCode () {
      const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let randomCode = ''
      const length = 6
      for (let i = 0; i < length; i++) {
        randomCode += characters.charAt(
          Math.floor(Math.random() * characters.length)
        )
      }
      return randomCode
    },
    // 将数字状态转换为状态文字
    getStatusText (status) {
      const statusMap = {
        0: '待核销',
        1: '已过期',
        2: '已核销',
        3: '待支付',
        4: '待领取'
      }
      return statusMap[status]
    }
  }
}
</script>

<style scoped>
.el-select-dropdown__item {
  height: auto !important;
}
.discount-condition {
  display: flex;
  align-items: center;
  gap: 8px;
}

.condition-text {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
}

.amount-input {
  width: 120px;
  flex-shrink: 0;
}
.period-conversion {
  margin-top: 8px;
  padding: 6px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.period-conversion .el-icon-time {
  color: #409eff;
  font-size: 14px;
}

.conversion-text {
  color: #606266;
  font-size: 13px;
  font-weight: 500;
}
</style>
